import { render } from "./full_head.vue?vue&type=template&id=52771db2&scoped=true"
import script from "./full_head.vue?vue&type=script&lang=js"
export * from "./full_head.vue?vue&type=script&lang=js"

import "./full_head.vue?vue&type=style&index=0&id=52771db2&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52771db2"]])

export default __exports__